import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";

const asPlainText = (value, fallback = "") => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return fallback;
};

const phaseActionLabel = (template, verb, nextFase) => {
  const name = asPlainText(nextFase && nextFase.name).trim();
  if (typeof template === "string") {
    return template.replace(/\{0\}/g, name).trim();
  }
  return (asPlainText(verb) + (name ? " " + name : "")).trim();
};

class ReverseFaseDialog extends React.Component {
  render() {
    const tournament = this.props.tournament || {};
    const nextFaseName = asPlainText(
      this.props.nextFase && this.props.nextFase.name
    ).trim();
    const undoLabel = phaseActionLabel(
      languages.results && languages.results.undoPhaseButton,
      languages.results && languages.results.reverse,
      this.props.nextFase
    );
    const titleLabel =
      asPlainText(languages.results && languages.results.reverse, "Undo") +
      (nextFaseName ? " " + nextFaseName : "");
    const participantWord = asPlainText(
      tournament.individualPlayers
        ? languages.teams && languages.teams.playersLow
        : languages.tournament && languages.tournament.teamsLow
    );
    const descriptionTemplate =
      languages.results && languages.results.reverseFaseDescription;
    const description =
      typeof descriptionTemplate === "string"
        ? descriptionTemplate.replace(/\{0\}/g, participantWord)
        : asPlainText(descriptionTemplate);
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{ overflow: "hidden" }}
          title={titleLabel}
        >
          <span
            style={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {titleLabel}
          </span>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          <DialogContentText style={{ paddingBottom: 5 }}>
            {description}
          </DialogContentText>
          {this.props.errorMessageReverse && (
            <DialogContentText style={{ color: "red" }}>
              {asPlainText(this.props.errorMessageReverse)}
            </DialogContentText>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general && languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleReverse}
            variant="contained"
            color="primary"
            title={undoLabel}
            style={{ maxWidth: "55%", minWidth: 0 }}
          >
            <span
              style={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {undoLabel}
            </span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ReverseFaseDialog;
